// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"bracketDropdown_fullWidth__J15jm","disclaimer":"bracketDropdown_disclaimer__lIMNU"};